export function easeOutCubic(t: number): number {
  if(t <= 0) {
    return 0
  }
  if(t >= 1) {
    return 1
  }
  return 1 - Math.pow(1 - t, 3)
}
